const formatCompactNumber = (num, prefix = '') => {
  if (Number.isNaN(num) || num == null) return `${prefix}0`;
  if (Math.abs(num) >= 1_000_000) return `${prefix}${(num / 1_000_000).toFixed(1)}M`;
  if (Math.abs(num) >= 1_000) return `${prefix}${(num / 1_000).toFixed(1)}k`;
  return num.toString();
};

const formatCurrencyCompact = (num) => formatCompactNumber(num, '$') || '$0.00';

const formatCurrency = (num, digits) => {
  if (Number.isNaN(num) || num == null) return '$0';
  return num.toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

const percentFormatter = (num, digits) => {
  if (Number.isNaN(num) || num == null) return '0%';
  return `${(num * 100).toFixed(digits)}%`;
};

const decimalFormatter = (num, digits) => {
  if (Number.isNaN(num) || num == null) return '0';
  return num.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export const outputFormatter = (value, format) => {
  if (value == null) return value;

  const number = Number(value);

  switch (format) {
    case 'percent_0':
      return percentFormatter(number, 0);
    case 'percent_1':
      return percentFormatter(number, 1);
    case 'percent_2':
      return percentFormatter(number, 2);
    case 'percent_3':
      return percentFormatter(number, 3);

    case 'decimal_0':
      return decimalFormatter(number, 0);
    case 'decimal_1':
      return decimalFormatter(number, 1);
    case 'decimal_2':
      return decimalFormatter(number, 2);
    case 'decimal_3':
      return decimalFormatter(number, 3);
    case 'decimal_k':
      return formatCompactNumber(number);

    case 'usd_0':
      return formatCurrency(number, 0);
    case 'usd_2':
      return formatCurrency(number, 2);
    case 'usd_k':
      return formatCurrencyCompact(number);

    case 'int':
      return Math.round(number).toString();

    case 'string':
    default:
      return String(value);
  }
};